import ApplicationController    from '../support/application_controller'
import SOTFLobbyMixin           from '../support/sotf_lobby_mixin'
import mixin                    from '../support/mixin'

export default class extends mixin(
  ApplicationController,
  SOTFLobbyMixin
) {

}
